import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Users,
  Package,
} from "lucide-react";
import { SegmentationCustomer } from "./segmentation/SegmentationCustomer";
import { SegmentationProduct } from "./segmentation/SegmentationProduct";

export default function Segmentation() {
  const [activeTab, setActiveTab] = useState<string>("customer");

  const segmentationTabs = [
    {
      id: "customer",
      name: "Customer",
      icon: Users,
    },
    {
      id: "product",
      name: "Product",
      icon: Package,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Segmentation</h1>
          <p className="text-muted-foreground">
            Manage customer and product segmentation
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          {segmentationTabs.map((tab) => (
            <TabsTrigger key={tab.id} value={tab.id} className="text-sm">
              <tab.icon className="h-4 w-4 mr-2" />
              {tab.name}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="customer" className="space-y-6">
          <SegmentationCustomer />
        </TabsContent>

        <TabsContent value="product" className="space-y-6 mt-6">
          <SegmentationProduct />
        </TabsContent>
      </Tabs>
    </div>
  );
}
